import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Progress } from 'reactstrap';
import DeleteButton from 'shared/components/buttons/Delete';
import styles from './ProgressBar.module.scss';

const ProgressBar = ({ value, onAbort, withTitle, className }) => (
  <div className={cn(styles.wrapper, className)}>
    <div className={styles.progress}>
      {withTitle && (<small className={styles.title}>{value}%</small>)}
      <Progress className={styles.bar} value={value} />
    </div>
    {onAbort && (
      <DeleteButton className={cn(styles.abort, { [styles.withTitle]: withTitle })} onClick={onAbort} />
    )}
  </div>
);

ProgressBar.propTypes = {
  value: PropTypes.number,
  onAbort: PropTypes.func,
  className: PropTypes.string,
};

ProgressBar.defaultProps = {
  value: 0,
  onAbort: null,
  className: null,
};

export default ProgressBar;
